import React, { useEffect, useState } from "react";
import {
  getDeviceList,
  syncBiotimeManual,
  checkBiotimeServer, 
} from "../../../actions/biotimeAction";
import { Table, Spin, Card, Tag, Button, message } from "antd";
import { connect } from "react-redux";
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
} from "@ant-design/icons"; 

const DeviceIndex = ({ getDeviceList, syncBiotimeManual }) => {
  const [loading, setLoading] = useState(true);
  const [devices, setDevices] = useState([]);
  const [error, setError] = useState(false);
  const [serverStatus, setServerStatus] = useState(null);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    checkServerStatus();
    fetchDevices();
  }, []);

  const checkServerStatus = async () => {
    const online = await checkBiotimeServer();
    setServerStatus(online ? "online" : "offline");
  };

  const fetchDevices = async () => {
    setLoading(true);
    setError(false);
    try {
      const result = await getDeviceList();
      if (result && Array.isArray(result)) {
        setDevices(result);
      } else if (result && Array.isArray(result.data)) {
        setDevices(result.data);
      } else {
        setDevices([]);
        setError(true);
      }
    } catch (e) {
      setDevices([]);
      setError(true);
      message.error("Biotime server is offline or unreachable");
      console.error("Biotime server error:", e);
    }
    setLoading(false);
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      const response = await syncBiotimeManual();
      if (response && response.message) {
        message.success(response.message);
      }
      await fetchDevices();
    } catch (err) {
      message.error("Sync failed.");
    }
    setSyncing(false);
  };

  const columns = [
    {
      title: "Device ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Serial Number",
      dataIndex: "sn",
      key: "sn",
    },
    {
      title: "Alias",
      dataIndex: "alias",
      key: "alias",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      key: "ip_address",
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: (state) =>
        String(state) === "1" ? (
          <CheckCircleTwoTone twoToneColor="#52c41a" />
        ) : (
          <CloseCircleTwoTone twoToneColor="#ff4d4f" />
        ),
    },
    {
      title: "Area",
      dataIndex: "area_name",
      key: "area_name",
    },
    {
      title: "User Count",
      dataIndex: "user_count",
      key: "user_count",
    },
    {
      title: "Transaction Count",
      dataIndex: "transaction_count",
      key: "transaction_count",
    },
  ];

  const renderServerStatus = () => {
    if (serverStatus === "online") {
      return <Tag color="green">Biotime Server is Running</Tag>;
    } else if (serverStatus === "offline") {
      return <Tag color="red">Biotime Server is Down</Tag>;
    } else {
      return <Tag color="default">Checking Server Status...</Tag>;
    }
  };

  return (
    <Card
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Biotime Devices</span>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {renderServerStatus()}
            <Button type="primary" loading={syncing} onClick={handleSync}>
              {syncing ? "Syncing..." : "Sync"}
            </Button>
          </div>
        </div>
      }
      style={{ margin: "20px" }}
    >
      <Spin spinning={loading}>
        <Table
          dataSource={devices}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 10 }}
          locale={{
            emptyText: error
              ? "No data — Biotime might be offline or unreachable"
              : "No devices found",
          }}
        />
      </Spin>
    </Card>
  );
};

export default connect(null, {
  getDeviceList,
  syncBiotimeManual,
})(DeviceIndex);
